import { Fragment } from "react";
import ImageCarousel from "../imageslider";

export default function MobileFriendly() {
  return (
    <Fragment>
      <div className="container-fluid horizontal-padding">
        <div className=" px-lg-6  a2Features text-center position-relative">
          <h2>MOBILE FRIENDLY</h2>
        </div>
        <div className="row position-relative text-center">
          <ImageCarousel />
        </div>
      </div>
    </Fragment>
  );
}
